import ColorPicker from '@/pages/design/components/ColorPicker';
import Card from '@/pages/design/components/Card';
import CardItem from '@/pages/design/components/CardItem';
import Title from '@/pages/design/components/Title';
import InputBar from '@/pages/design/components/InputBar';
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ColorPicker: ColorPicker,
    Card: Card,
    CardItem: CardItem,
    Title: Title,
    InputBar: InputBar
  },
  data: function data() {
    return {
      form: this.$form.createForm(this)
    };
  }
};